import TabsUI from "@/shared/components/atoms/TabsUI";
import { useState, useMemo } from "react";
import { t } from "i18next";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useBranchesQuery } from "@/app/branchs/branchs.api";

import SummaryComponent from "./Componennts/SummaryComponent";
import ClientProfile from "./Componennts/ClientProfileComponent";
import RevenueComponent from "./Componennts/RevenueComponent";
import ExpensesComponent from "./Componennts/ExpensesComponent";
import BenefitsComponent from "./Componennts/BenefitsComponent";
import CaptationFidelizationComponent from "./Componennts/CaptationFidelizationComponent";
import UtilizationOccupationComponent from "./Componennts/UtilizationOccupationComponent";
import ServiceComponent from "./Componennts/ServiceComponent";
import TrainingNutritionComponent from "./Componennts/TrainingNutritionComponent";

import { Permission } from "@/shared/hooks/usePermission";

am4core.useTheme(am4themes_animated.default);

const KpiPage = () => {
  const [tab, setTab] = useState("client-profile");
  const { data: branches } = useBranchesQuery({});

  const tabs = useMemo(
    () => [
      {
        id: "summary",
        name: t("user.views.summary"),
        permission: Permission.KPI_SUMMARY,
      },
      {
        id: "client-profile",
        name: t("share.views.totalusers"),
        permission: Permission.KPI_CLIENT_PROFILE,
      },
      {
        id: "revenue",
        name: t("user.views.revenue"),
        permission: Permission.KPI_REVENUE,
      },
      {
        id: "expenses",
        name: t("share.views.main_expenses"),
        permission: Permission.KPI_EXPENSES,
      },
      {
        id: "benefits",
        name: t("share.views.main_benefits"),
        permission: Permission.KPI_PROFITS,
      },
      {
        id: "captation-fidelization",
        name: t("share.views.main_captation_fidelization"),
        permission: Permission.KPI_ACQUISITION_AND_RETENTION,
      },
      {
        id: "utilization-occupation",
        name: t("share.views.main_utilization_occupation"),
        permission: Permission.KPI_UTILIZATION_AND_OCCUPANCY,
      },
      {
        id: "service",
        name: t("share.views.main_service_rating"),
        permission: Permission.KPI_SERVICE_EVALUATION,
      },
      {
        id: "training-nutrition",
        name: t("user.views.main_message23"),
        permission: Permission.KPI_TRAINING_AND_NUTRITION_PROGRAMS,
      },
    ],
    [t]
  );

  return (
    <>
      <TabsUI tabs={tabs} handleChange={setTab} current={tab} />
      <div>
        {tab === "summary" && <SummaryComponent branches={branches} />}
        {tab === "client-profile" && <ClientProfile branches={branches} />}
        {tab === "revenue" && <RevenueComponent branches={branches} />}
        {tab === "expenses" && <ExpensesComponent branches={branches} />}
        {tab === "benefits" && <BenefitsComponent branches={branches} />}
        {tab === "captation-fidelization" && <CaptationFidelizationComponent />}
        {tab === "utilization-occupation" && (
          <UtilizationOccupationComponent branches={branches} />
        )}
        {tab === "service" && <ServiceComponent />}
        {tab === "training-nutrition" && <TrainingNutritionComponent />}
      </div>
    </>
  );
};

export default KpiPage;
